<mat-drawer-container class="example-container" autosize>
  <mat-drawer #drawer class="example-sidenav" mode="over">
    <!-- Drawer Navbar -->
    <div
      class="tw-flex tw-justify-between tw-bg-white tw-p-3 tw-items-center tw-h-[56px] tw-w-full tw-sticky tw-top-0 tw-border-b tw-border-gray-200"
    >
      <i
        role="button"
        tabindex="0"
        (keydown.enter)="drawer.toggle()"
        (click)="drawer.toggle()"
        class="bi bi-list tw-text-xl tw-text-primary tw-cursor-pointer"
      ></i>
      <span class="tw-text-primary tw-text-lg tw-font-semibold">{{
        "Menu" | translate
      }}</span>
      <img
        src="../../../assets/new-icons/person.png"
        alt="profile img"
        class="tw-size-8 tw-rounded-full tw-cursor-pointer"
        [matMenuTriggerFor]="userMenu"
        aria-label="User menu"
      />
    </div>
    @for (item of mobileMenuItems; track $index) { @if (item.permission) {
    <app-mobile-menu-item
      (click)="drawer.toggle()"
      [label]="item.label"
      [icon]="item.icon"
      [route]="item.route"
    >
    </app-mobile-menu-item>
    } }
  </mat-drawer>
  <!-- Container -->

  <div class="tw-m-0">
    <!-- Navbar -->
    <div
      class="tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-2 tw-py-3 tw-h-[60px] tw-top-0 tw-shadow-sm tw-border-b tw-border-gray-200"
    >
      <div class="tw-flex tw-items-center tw-gap-2">
        <i
          role="button"
          tabindex="0"
          (keydown.enter)="drawer.toggle()"
          (click)="drawer.toggle()"
          class="bi bi-list tw-text-xl tw-text-bold tw-text-primary tw-cursor-pointer"
        ></i>
        <button
          mat-icon-button
          class="tw-text-primary"
          routerLink="/"
          aria-label="Go home"
        >
          <mat-icon>home</mat-icon>
        </button>
      </div>

      <span
        class="tw-text-primary tw-text-lg flex items-center gap-3 cursor-pointer tw-font-semibold"
        (click)="goBack()"
        tabindex="0"
        role="button"
      >
        @if (!language.isArabic) {
        <mat-icon class="tw-pt-1 clickable tw-mx-3">arrow_back</mat-icon>
        }

        {{ pageName | translate }}
        @if (language.isArabic) {
        <mat-icon class="tw-pt-1 clickable tw-mx-3">arrow_back</mat-icon>
        }
      </span>

      <div class="tw-flex tw-items-center tw-gap-4 tw-text-sm tw-text-gray-600">
        <div
          class="tw-hidden md:tw-flex tw-items-center tw-gap-2 tw-bg-[rgba(15,42,61,0.06)] tw-px-3 tw-py-1.5 tw-rounded-full"
        >
          <mat-icon class="tw-text-primary">schedule</mat-icon>
          <span class="tw-font-medium">{{ currentTime }}</span>
        </div>
        <!-- menu -->
        <div class="tw-text-center tw-flex tw-items-center tw-gap-3">
          <img
            src="../../../assets/new-icons/person.png"
            alt="profile img"
            class="tw-size-8 tw-rounded-full tw-cursor-pointer"
            [matMenuTriggerFor]="userMenu"
            aria-label="User menu"
          />

          <!-- Online/Offline indicator -->
          <div class="tw-flex tw-items-center tw-gap-2">
            <span
              class="status-dot"
              [class.status-online]="isOnline"
              [class.status-offline]="!isOnline"
            ></span>
            <span
              class="tw-text-xs tw-font-medium"
              [class.tw-text-green-600]="isOnline"
              [class.tw-text-red-600]="!isOnline"
            >
              {{ (isOnline ? "Online" : "Offline") | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item (click)="userProfile()">
    <i class="bi bi-person tw-mr-2"></i>{{ "Profile" | translate }}
  </button>
  <button mat-menu-item (click)="appVersion()">
    <i class="bi bi-info-circle tw-mr-2"></i>{{ "App version" | translate }}
  </button>
  <button mat-menu-item>
    <app-switcher-language></app-switcher-language>
  </button>
  <button mat-menu-item (click)="logout()">
    <i class="bi bi-box-arrow-right tw-mr-2"></i>{{ "Logout" | translate }}
  </button>
</mat-menu>

@if (showReload) {
<div
  class="reload-toast tw-fixed tw-z-50 tw-top-3 tw-left-1/2 -tw-translate-x-1/2 tw-bg-amber-100 tw-text-amber-900 tw-shadow-lg tw-rounded-full tw-border tw-border-amber-200 tw-px-4 tw-py-2 tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-select-none"
  (click)="reloadApp()"
  role="button"
  aria-live="polite"
  aria-label="New version available. Click to reload."
  tabindex="0"
  (keydown.enter)="reloadApp()"
>
  <span class="icon-wrapper">
    <i class="bi bi-arrow-repeat"></i>
  </span>
  <span class="tw-text-sm">
    {{ "A new version is available — click to reload" | translate }}
  </span>
</div>
}
